

export default {
    //过滤HTML标签文本中img标签
    filterphoto: function (txt) {
        var reTag = /<img(?:.|\s)*?>/g;
        return txt.replace(reTag, "");
    },
    //过滤HTML标签文本中所有标签，留下纯文本
    filterall: function (txt) {
        return txt.replace(/<.*?>/g, "");
    },
    //手机中间四位
    phoneOmitted: function (txt) {
        var reg = /^(\d{3})\d{4}(\d{4})$/;
        return txt.replace(reg, "$1****$2");
    },
}